import React from 'react';
import { connect } from 'react-redux';

import Pagination from './Pagination';


function QuestionPagination({ currentAssessment, questions, currentQuestionIndex, putAssessment, navigate, currentSection }) {
  const urlPrefix = currentAssessment.id
    ? '/assessments/' + currentAssessment.id + '/'
    : '/assessments/new/';
  const prevUrl = urlPrefix + (currentQuestionIndex - 1);
  const nextUrl = currentQuestionIndex === Object.values(questions).length
    ? urlPrefix + 'final-comments'
    : urlPrefix + (currentQuestionIndex + 1);
  const introUri = currentSection.hasIntro ? 'intro' : 'preface';
  return (
    <div className="new-assessment-detail__pagination-wrapper">
      <Pagination
        prevUrl={currentQuestionIndex === 1 ? urlPrefix + introUri : prevUrl}
        nextUrl={nextUrl}
        questionNumber={currentQuestionIndex}
        totalQuestions={Object.keys(questions).length}
        putAssessment={putAssessment}
        navigate={navigate}
        currentAssessmentId={currentAssessment.id}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    questions: state.sections[state.assessments.currentAssessment.section].questions,
    currentAssessment: state.assessments.currentAssessment,
  };
}

export default connect(mapStateToProps)(QuestionPagination);



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionPagination.js